<!-- <div>

  <footer role="contentinfo">
  <div class="footer-middle">
  <div class="container">
  <div class="row">
  <div class="col-md-12 col-sm-12 col-xs-12">
  
  <div class="col-md-3 col-sm-12 col-xs-12">
 
  <div class="footer-pad">
  <h4>Company</h4>
  <ul class="list-unstyled">
  <li><a href="#"></a></li>
  <li><a href="#">About Us</a></li>
  <li><a href="#">Media</a></li>
  <li><a href="#">Store Locator</a></li>
  <li><a href="#">Career</a></li>
  <li><a href="#">Enquiry</a></li>
  </ul>
  </div>
  </div>
  <div class="col-md-3 col-sm-12 col-xs-12">
 
  <div class="footer-pad">
  <h4>Customer Service</h4>
  <ul class="list-unstyled">
  <li><a href="#">FAQ</a></li>
  <li><a href="#">Returns And Refund</a></li>
  <li><a href="#">Request an appointment</a></li>
  <li><a href="#">Privacy Policy</a></li>
  <li><a href="#">Cancellation Policy</a></li>
  <li><a href="#">SiteMap</a></li>
  </ul>
  </div>
  </div>
  <div class="col-md-3 col-sm-12 col-xs-12">
  
  <div class="footer-pad">
  <h4>QuickLinks</h4>
  <ul class="list-unstyled">
  <li><a routerLink="/companyProfile">Our Profile</a></li>
  <li><a routerLink="/login" *ngIf="!isToken()">Login</a></li>
  <li><a routerLink="/signup" *ngIf="!isToken()">Sign Up</a></li>
  <li><a routerLink="/bug" (click)="feedbackUrl('Bug')" >Bug</a></li>
  <li><a routerLink="/comment" (click)="feedbackUrl('Comment')">Comment</a></li>
  <li><a routerLink="/questions"(click)="feedbackUrl('Questions')">Question</a></li>
  <li><a routerLink="/feedback"(click)="feedbackUrl('Feedback')">Feedback</a></li>
  
  </ul>
  </div>
  </div>
  <div class="col-md-3 col-sm-12 col-xs-12">
 
  <div class="footer-pad">\
  <h4>Follow us</h4>
  <ul class="list-unstyled">
  
  <li><a href="#"><i class="fab fa-facebook-square" style="font-size:22px;color:white" title="Facebook"></i></a></li>
  <li><a href="#"><i class="fab fa-instagram" style="font-size:22px;color:white" title ="Instagram"></i></a></li>
  <li><a href="#"><i class="fab fa-google-plus-square" style="font-size:22px;color:white" title ="Google plus"></i></a></li>
  <li><a href="#"><i class="fab fa-linkedin-square" style="font-size:22px;color:white" title ="LinkedIn"></i></a></li>
  </ul>
  </div>
  </div>
  </div>
  </div>
  </div>
  
  </div>
  <div class="copyright text-center">
  Copyright &copy; 2019 <span>Home Fabrics</span>
  </div>
  </footer> -->



  <footer class="bgpurple main ">
    <div class="container">
        <div class="row">
            <div class="col-md-2">

            </div>

            <div class="col-md-8 col2">
                <div class="center">
                    <a class="navbar-brand-centered" href="#">
                        <img src="assets\img\logo.png" alt="home-fabrics-logo">
                    </a>
                    <!-- <h5 class="link-title">Quick Links</h5> -->


                    <div class="footer-link">

                        <!-- <a href="/homefabrics/terms-and-conditions" class="brr">Terms & Conditions</a> -->
                        <!-- <a href="http://54.187.185.32/homefabrics/privacy-policy"  class="brr">Copyright</a> -->
                        <!-- <a href="/homefabrics/privacy-policy"  >Privacy Policy</a> -->
                        <!-- <a href=""  class="brr">Disclaimer</a> -->
                      
                        <a routerLink="/termsCondition" (click)="termsConditionUrl()" routerLinkActive="current"
                            class="brr">Terms & Conditions</a>
                        <a routerLink="/privacyPolicy" (click)="privacyPolicyUrl()" routerLinkActive="current">Privacy
                            Policy</a>

                        <!-- <a href="index.php">Home</a> -->
                        <!-- <a href="">Site Map</a> -->
                        <!-- <a href="<?php echo base_url('our-profile') ?>">Our Profile</a></li> -->
                    </div>

                    <div class="social-media">
                        <a href="https://www.facebook.com/HomeFabrics2004" target="_blank"                            rel="noopener noreferrer">
                            <img src="assets/img/fb.png" alt="">
                        </a>
                       
                        <a href="http://www.twitter.com/HomeFabrics2004" target="_blank" rel="noopener noreferrer">                            <img src="assets/img/tw.png" alt="">
                        </a>
                        <a href="https://www.instagram.com/homefabrics2004/#" target="_blank"
                            rel="noopener noreferrer">
                            <img src="assets/img/in.png" alt="">
                        </a>
                    </div>
                    <ul class="footer-link">
                        <li><a href="mailto:hf@homefabricsindia.com?cc=po@homefabricsindia.com">Email</a></li>
                        
                    </ul>
                </div>


            </div>
            <div class="col-md-2"></div>
         
        </div>


    </div>
    <div class="copyright">
        <div class="container">
            <p> <span class="float-left"> &copy; {{ currentYear }} HOME FABRICS ALL RIGHT RESERVED</span> <span
                    class="float-right">Developed By HOME FABRICS</span></p>
        </div>
    </div>
</footer>
<script src=""></script>
<!-- <div class="footer-scroll">
      <a class="scrollup" href="#navbar" style> 
         <fa name="chevron-circle-up"></fa></a>
         <a class="scroll-up" href="#top" style><i class="fa fa-chevron-circle-up fa-3x"></i></a>
</div> -->

<div class="footer-scroll">
    <a class="scroll-up" (click)="scrollToTop()">
        <i class="fa fa-chevron-circle-up fa-3x"></i>
    </a>
</div>



<!-- <div class="preloader" style="display:block">
    <div class="loader rubix-cube">
        <div class="layer layer-1"></div>
        <div class="layer layer-2"></div>
        <div class="layer layer-3 color-1"></div>
        <div class="layer layer-4"></div>
        <div class="layer layer-5"></div>
        <div class="layer layer-6"></div>
        <div class="layer layer-7"></div>
        <div class="layer layer-8"></div>
    </div>
</div> -->